var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 75,
    viewBox: "0 0 155 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4451 0.627997C18.4171 0.627997 10.1291 5.21599 7.90909 8.176V0.775995H0.0650927V26.676H0.213092C0.213092 25.788 0.0650927 26.38 0.0650927 27.268V74.48H7.90909V27.268C7.90909 16.76 16.4931 8.62 27.4451 8.62C38.5451 8.62 46.9811 16.76 46.9811 27.268V74.48H54.9731V27.268C54.9731 12.764 42.3931 0.627997 27.4451 0.627997ZM117.681 0.775995C97.7012 0.775995 80.9772 17.5 80.9772 37.48C80.9772 57.46 97.7012 74.184 117.681 74.184C137.661 74.184 154.385 57.46 154.385 37.48C154.385 17.5 137.661 0.775995 117.681 0.775995ZM117.681 66.34C101.549 66.34 88.8212 53.612 88.8212 37.48C88.8212 21.348 101.549 8.62 117.681 8.62C133.813 8.62 146.541 21.348 146.541 37.48C146.541 53.612 133.813 66.34 117.681 66.34Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/NO.9d19c51e40c2192af2c36effb52917ba.svg";
export { ForwardRef as ReactComponent };